import PropTypes from 'prop-types';
import React from 'react';
import { Helmet } from 'react-helmet';
import { injectIntl } from 'react-intl';

import messages from './messages';

const GiftPageHelmet = ({ intl, categoryName, cardName }) => {
  let title;

  if (categoryName) {
    title = intl.formatMessage(messages.categoryTitle, { categoryName });
  } else if (cardName) {
    title = intl.formatMessage(messages.cardDetailTitle, { cardName });
  } else {
    title = intl.formatMessage(messages.baseTitle);
  }

  return (
    <Helmet
      meta={[
        {
          name: 'description',
          content: intl.formatMessage(messages.description),
        },
      ]}
      title={title}
    />
  );
};

GiftPageHelmet.propTypes = {
  cardName: PropTypes.string,
  categoryName: PropTypes.string,
  intl: PropTypes.object,
};

export default injectIntl(GiftPageHelmet);
